// 시공사례 순서 낙관적 잠금 — 화면이 읽을 때 본 전체 순서(기준값)가 지금 순서와 다르면 저장하지 않는다(0061).

export const PORTFOLIO_ORDER_STALE_HINT = "portfolio_order_stale";

export const PORTFOLIO_ORDER_STALE_MESSAGE =
  "다른 곳에서 순서가 바뀌었습니다 — 최신 순서로 다시 불러왔으니 한 번 더 옮겨 주세요";

// 기준값 없이 부르면 거절한다(0070) — 잠금 없이 덮어쓰는 길을 남기지 않는다.
export const PORTFOLIO_ORDER_EXPECTED_MISSING_MESSAGE = "순서 기준값이 없습니다 — 새로고침한 뒤 다시 옮겨 주세요";

export class PortfolioOrderStaleError extends Error {
  constructor(message: string = PORTFOLIO_ORDER_STALE_MESSAGE) {
    super(message);
    this.name = "PortfolioOrderStaleError";
  }
}

export const isPortfolioOrderStale = (error: unknown): error is PortfolioOrderStaleError =>
  error instanceof PortfolioOrderStaleError;

// 기준값이 지금 줄 전부를 한 번씩 담고 sort_order 가 줄지 않으면 같은 순서다(동점끼리의 id 정렬은 JS·SQL 이 다를 수 있어 안 따진다).
export const isOrderStale = (
  current: readonly { id: string; sort_order: number }[],
  expected: readonly string[]
): boolean => {
  if (current.length !== expected.length) return true;
  const orderOf = new Map(current.map((row) => [row.id, row.sort_order]));
  const seen = new Set<string>();
  let prev = Number.NEGATIVE_INFINITY;
  for (const id of expected) {
    const at = orderOf.get(id);
    if (at === undefined || seen.has(id) || at < prev) return true;
    seen.add(id);
    prev = at;
  }
  return false;
};

// 저장 뒤 새로고침이 착지할 때까지(서버 목록 키가 잠글 때 그대로인 동안) 드래그를 막는다 — 먼저 끌면 착지하며 그 순서가 버려진다.
export const isAwaitingRefresh = (settle: { key: string } | null, rowsKey: string): boolean =>
  settle !== null && settle.key === rowsKey;

// 새로고침이 끝내 목록을 바꾸지 않아도(다른 쪽만 바뀐 stale 등) 이만큼 뒤에는 드래그를 푼다.
export const REORDER_SETTLE_TIMEOUT_MS = 5000;
